<template>
	<div>
		<span class="icon-label icon-label-success" v-if="current"><v-icon>far fa-check</v-icon> Current</span>
		<span class="icon-label icon-label-warning" v-else><v-icon>far fa-exclamation</v-icon> Obsolete</span>
	</div>
</template>

<script>
export default {
	props: {
		current: Boolean,
	},
	data() {
		return {};
	},
};
</script>
